import React from 'react';

const Tags = ({ tags = [] }) => {
  // Filter out empty or whitespace-only tags
  const validTags = tags.filter(tag => tag && tag.trim());
  
  // Return nothing if no valid tags
  if (!validTags.length) return null;

  return (
    <div className="flex space-x-2 overflow-x-auto py-2">
      {validTags.map((tag, index) => (
        <span 
          key={index} 
          className="bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 text-xs px-3 py-1 rounded-md"
        >
          #{tag}
        </span>
      ))}
    </div>
  );
};

export default React.memo(Tags);